import * as Yup from 'yup'

const forgotPasswordSchema = Yup.object().shape({
  email: Yup.string()
    .email('Please povide a valid email address.')
    .required('Please provide your email address.'),
})

export default forgotPasswordSchema
